/**
 * Get the domain for cookie operations
 * @returns {string} The domain to use for cookies
 */
export const getDomain = () => {
  const hostname = window.location.hostname;

  // Handle localhost/development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return hostname;
  }

  // For production domains, extract the main domain
  // This handles subdomains by returning the main domain
  const parts = hostname.split('.');
  if (parts.length >= 2) {
    return parts.slice(-2).join('.');
  }

  return hostname;
};

export default getDomain;
